@if (data?.links?.length) {
  <div class="container article-related">
    <div class="font-700 text-lg slg:text-xl mb-4 slg:mb-6">
      {{ data.name }}
    </div>
    <ul class="grid grid-cols-1 slg:grid-cols-2 gap-x-4">
      @for (related of data.links | slice: 0 : maxItemsToDisplay(); track related.url) {
        <li class="flex max-w-full overflow-hidden">
          <a
            effy-link
            class="w-full justify-start"
            [size]="size()"
            [color]="EffyLinkStyle.POWER_BLUE"
            [href]="related.url | safeResourceUrl"
          >
            @defer (on viewport) {
              <mat-icon class="flex items-center flex-shrink-0 w-4" [svgIcon]="chevronRight" />
            } @placeholder {
              <span> > </span>
            }
            <span class="block truncate">{{ related.title }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
}
